import "./styles.css";
import "./dom/index";

import Introduction from "./dom/pages/Introduction";
import { isDesktop } from "./experience/utils";
import { revealDesktopPage } from "./dom/pages/DesktopPage";

if (isDesktop) revealDesktopPage();
else Introduction();
